<template>
  <div class="home">
    <Header/>

    <!-- <Slideshow/> -->
    
    <SelectedWork id="projects"/>

    <!-- <div style="background-color: #ccc;">
      <router-link to="/work/algorhythm">Algo</router-link>
      <br>
      <router-link to="/work/revir">Revir</router-link>
    </div> -->

    <Index id="index"/>

    <Footer id="contact"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import LogoAni from '@/components/LogoAni.vue'
import Slideshow from '@/components/Slideshow.vue'
import SelectedWork from '@/components/SelectedWork.vue'
import Index from '@/components/Index.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Header,
    LogoAni,
    Slideshow,
    SelectedWork,
    Index,
    Footer
  }
}
</script>
<style scoped lang="scss">
@import "../scss/_vars.scss";
@import "../scss/_mixins.scss";

</style>
